// ----------------------------------------------------------------------------
// Snippet: Form Kit
// ----------------------------------------------------------------------------
//
// ----------------------------------------------------------------------------

// -------------------------------------
// Dependencies
// -------------------------------------

import $ from 'jquery';

// Scripts
import './form-handler-ajax';
import './form-handler-native';
import './form-validation-helper';
import './form-validation-mailcheck';
import './form-validation';
import './form-increment';
import './form-localization';

// Styles
import './_forms.scss';

// Add jQUery Validation to all forms 
// const validate = require('jquery-validation');
$('.form').not('.form--custom-validation').each(function() {
    $(this).validate();
});

$(document).ready(function(){

    $('.form__submit--ajax').on('click', function(e){
        e.preventDefault();
        var $form = $(this).parents('.form');
        if($form.valid()) {
           $form.submit();
        }
    })
})
